export default class Contact {

    constructor() {
        if (document.querySelector('#show.page-contact') !== null) {
            this.initMaps();
        }
    }

    initMaps() {
        const element = document.getElementById('map');

        const map = new google.maps.Map(document.getElementById('map'), {
            zoom: 12,
            center: {lat: parseFloat(element.dataset.lat), lng: parseFloat(element.dataset.lng)}
        });

        const marker = new google.maps.Marker({
            position: {lat: parseFloat(element.dataset.lat), lng: parseFloat(element.dataset.lng)},
            map: map,
            icon: '/img/icon-map.png'
        });
    }
}
